import { FC } from 'react'
import { times } from 'lodash'
import { useAppSelector } from '../../../redux'
import { RenderSlate } from '../..'
import { StyledLessonAbout } from '.'

const LessonAbout: FC = () => {
  const { lesson, tab, loading } = useAppSelector((state) => state.course)

  if (tab !== 'about' && !loading) {
    return null
  }

  return (
    <StyledLessonAbout>
      {!loading && <RenderSlate html={lesson?.description} />}
      {loading && (
        <div className="skel">
          {times(5, (index) => {
            return <div key={index} />
          })}
        </div>
      )}
    </StyledLessonAbout>
  )
}

export default LessonAbout
